// src/components/Annexures.jsx
import { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
} from "@mui/material";
import GlobalButton from "../../common/GlobalButton"; // Add this import
import RestartAltIcon from "@mui/icons-material/RestartAlt";

export default function Annexures() {
  const [open, setOpen] = useState(false);
  return (
    <Box>
      {/* Button to open the modal */}
      <Tooltip title="Download Annexures" arrow>
        <GlobalButton
          sx={{
            minWidth: 80,
            height: 36,
            px: 2,
            py: 0.5,
          }}
          onClick={() => setOpen(true)}
        >
          Annexures Files
        </GlobalButton>
      </Tooltip>

      {/* Modal Dialog */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        {/* <DialogTitle>Annexures</DialogTitle> */}
        <DialogContent>
          <iframe
            height="500px"
            width="100%"
            frameborder="0"
            allowTransparency="true"
            scrolling="auto"
            src="https://creatorapp.zohopublic.com/sst1source/source-erp/report-embed/All_Annexures/CtSFbTN7NjyXB7HT9RpzQOsQT3HzKSeewOsq4BVr97sDyPE6SdJfW2WxM0vTPx3pWyE4RkJRY9vnwTN4DPD86KSERzuxYg9SgmbN"
          ></iframe>
        </DialogContent>
        <DialogActions>
          {/* Close button */}

          <GlobalButton
            size="small"
            variant="contained"
            onClick={() => setOpen(false)}
            icon={<RestartAltIcon />}
            sx={{ minWidth: 80, height: 36, px: 2, py: 0.5 }}
          >
            RESET
          </GlobalButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
